import React from 'react';
export class CeremonyTableUI extends React.Component {
    constructor(props) {
        super(props);

        this.onViewClick = this.onViewClick.bind(this);
        this.onPrizeClick = this.onPrizeClick.bind(this);
        this.onStartClick = this.onStartClick.bind(this);
        this.onCalculateClick = this.onCalculateClick.bind(this);
        this.onDisable = this.onDisable.bind(this);
        this.onShowChances = this.onShowChances.bind(this);

    }

    onStartClick(e) {
        if (typeof this.props.onStartClick === "function") {
            this.props.onStartClick(e);

        }
    }

    onCalculateClick(e) {
        if (typeof this.props.onCalculateClick === "function") {
            this.props.onCalculateClick(e);

        }

    }

    onDisable(e) {

        if (typeof this.props.onDisable === "function") {
            this.props.onDisable(e);

        }
    }

    onShowChances(e,d) {

        console.log(e);
        if (typeof this.props.onShowChances === "function") {
            this.props.onShowChances(e,d);

        }
    }
    onViewClick(e) {
        //   console.log("view click");
        if (typeof this.props.onViewClick === "function") {
            this.props.onViewClick(e);

        }
    }


    onPrizeClick(e) {

        //     console.log("prize click");
        if (typeof this.props.onPrizeClick === "function") {
            this.props.onPrizeClick(e);
        }
    }


    render() {
        console.log(this.props.data);

        if (this.props.data != null && this.props.data.length > 0) {
            var Rows = this.props.data.map(
                (data) =>

                    <tr key={data.ceremony.id} >


                        <td>
                            {data.ceremony.id}
                        </td>
                        <td>
                            {data.ghoreName}
                        </td>
                        <td>
                            {data.ceremony.lotteryType == "1" ? "اتوماتیک" : "گوی"}
                        </td>

                        <td>
                            {data.prizeDesc}
                        </td>
                        <td>
                            {data.ceremony.isWeighted == true ? "1" : "0"}
                        </td>
                        <td>
                            {data.createPersianDate}
                        </td>



                        <td>
                            <input type="button" className="btn btn-primary" value="محاسبه ردیف های قرعه کشی" onClick={() =>this.onCalculateClick(data.ceremony.id)} disabled ={data.ceremony.lotteryKind==1} />
                        </td>

                        <td>
                            <input type="button" className="btn btn-primary" value="ردیف های قرعه کشی " onClick={() =>this.onShowChances(data.ceremony.id,data.ceremony.lotteryKind)} />
                        </td>

                        <td>
                            <input type="button" className="btn btn-primary" value="ادامه" onClick={() =>this.onStartClick(data.ceremony.id)} />
                        </td>

                        <td>
                            <input type="button" className="btn btn-primary" value="ابطال" onClick={() =>this.onDisable(data.ceremony.id)} />
                        </td>



                    </tr>

            );
        }
        else {
            Rows = <tr><td colSpan="3">سطری وجود ندارد</td></tr>;
        }

        return (
            <div className="col-lg-12">
                <div className="">

                    <div className="table-responsive ">
                        <table className="table  table-striped text-center">
                            <thead>
                                <tr>
                                    <th>
                                        شناسه
                                    </th>
                                    <th>
                                        نام قرعه کشی
                                    </th>
                                    <th>
                                        نوع قرعه کشی
                                    </th>
                                    <th>
                                        جایزه
                                    </th>
                                    <th>
                                        وزن دار
                                    </th>
                                    <th>
                                        تاریخ
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Rows}
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        );

    }
}
/*
function printPrice(x) {


    // console.log("x:" + x);
    if (typeof (x) == "undefined")
        return "";

    if (x == null || x === "")
        return "";

    x = parseInt(x);

    return MytoLocaleString(x);
}

function MytoLocaleString(s) {

    var s1 = s.toLocaleString();
    var p = new Number(Math.floor(s) + 0.1);    // similar value but decimal
    var p1 = p.toLocaleString();
    var index;
    var point;
    for (index = p1.length - 1; index > 0; index--) { // find decimal point in dummy
        point = p1.charAt(index);
        if (point < '0' || point > '9')
            break;
    }
    if (index > 0) {
        index = s1.lastIndexOf(point);          // find last point in string
        if (index > 0)
            s1 = s1.slice(0, index);            // truncate decimal part

        return s1;
    }
    return "";
}
*/


// WEBPACK FOOTER //
// ./src/tables/ceremony/CeremonyTableUI.js